// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { userInformationStyles } from "@sc/Overrides/Widgets/AccountSettings/AccountSettingsUserInformation";
import { css } from "styled-components";

userInformationStyles.userInformationTitle = {
    variant: "h2",
    size: 20,
    css: css`
        line-height: 26px;
    `,
};

userInformationStyles.userInformationGridItem = {
    width: 12,
    css: css`
        position: relative;
        padding-bottom: 5px;
        &&& {
            max-width: 450px;
        }
    `,
};

userInformationStyles.changePasswordLink = {
    css: css`
        font-weight: bold;
        font-size: 12px;
        line-height: 13px;
        position: absolute;
        right: 15px;
    `,
};

userInformationStyles.userInformationContainer = {
    css: css`
        & ${GridOffset} {
            margin-bottom: 0;
        }
    `,
};